/**
 * The catch-all.
 *
 * Reachable in exactly one ordinary way — an old link, usually one we sent —
 * so the page's job is to get somebody back to their licenses in one click
 * rather than to be clever about it.
 */

import { PageHeader } from "@/components/PageHeader";
import { Notice } from "@/components/deck";
import { Button } from "@/components/ui/button";
import { useSession } from "@/lib/session";
import { Link, useLocation } from "react-router";

export function NotFoundRoute() {
  const { pathname } = useLocation();
  const { state } = useSession();
  const signedIn = state?.signed_in === true;

  return (
    <div className="mx-auto max-w-xl">
      <PageHeader code="404" label="Not found" title="There is nothing at this address" />
      <Notice
        tone="marker"
        label="Wrong turn"
        action={
          <Button asChild size="sm">
            <Link to={signedIn ? "/" : "/signin"}>{signedIn ? "Your licenses" : "Sign in"}</Link>
          </Button>
        }
      >
        <span className="t-data break-all text-ink">{pathname}</span> is not a page here. If you
        followed a link from us, it has moved — everything lives under your licenses now.
      </Notice>
    </div>
  );
}
